export default __webpack_public_path__ + "static/media/icam-logo-full-horiz-1c-white.04006ecf.svg";